<template>
  <div>
    <b-modal
      v-model="wipeconfirm"
      hide-footer
      title="Delete survey permanently?"
    >
      WARNING! This operation will physically delete ALL information for this survey, including survey participants, answers to survey questions, and all reports.
      <p><strong>THIS OPERATION CANNOT BE REVERSED.</strong></p>
      <b-button
        class="mt-3"
        variant="danger"
        block
        @click="survey_deletefromdatabase(wipesurvey)"
      >
        Delete
      </b-button>
      <b-button
        class="mt-2"
        variant="secondary"
        block
        @click="wipeconfirm=false;wipesurvey=false;"
      >
        Cancel
      </b-button>
    </b-modal>
    <b-modal
      v-model="wipeprogress"
      hide-footer
      title="Permanently deleting survey"
    >
      <b-row>
        <div class="col-12 text-center">
          <h5>Deleting survey</h5>
      </div>
      </b-row>
      <div class="col-12 text-center">
        <b-spinner
          style="width: 4rem; height: 4rem;"
          type="grow"
          variant="danger"
        ></b-spinner>
      </div>
    </b-modal>
    <b-modal
      id="deleteconfirm"
      hide-footer
    >
      D ya?
    </b-modal>
    <b-table
      striped
      responsive
      hover
      :busy="loading"
      :items="surveys"
      :fields="fields"
      :filter="surveytype"
      :filter-function="filter_it"
      class="table surveytable"
      @row-clicked="openSurveyPage"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle mr-2" />
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:head(select)>
        <b-form-checkbox
          v-model="selected"
          @click.native.stop
          @change="selectall(selected)"
        />
      </template>
      <!-- <template v-slot:cell(select)="data">
        <div
          style="padding-top: 4px;height: 36px; vertical-align: middle !important"
        >
          <b-form-checkbox
            v-model="data.item.selected"
            @input="countselected"
          />
        </div>
      </template> -->
      <template v-slot:cell(survey_type_id)="data">
        {{ data.value }}
      </template>
      <template v-slot:cell(survey_status)="data">
        <SurveyProgressBar
          :survey_id="data.item.id"
          :progressvalue="data.item.completecount"
          :progressmax="data.item.membercount"
          :progressvariant="
            data.item.completecount == data.item.membercount
              ? 'bg-success'
              : 'bg-default'
          "
        />
      </template>
      <template v-slot:cell(survey_name)="data">
        <span
          :class="`${anon ? 'g-anon' : '' }`"
        >
          {{ data.item.survey_name }}&nbsp;&nbsp;
        </span>
        <span class="text-mute">({{ data.item.id }}) </span>
      </template>
      <template v-slot:cell(group_id)="data">
        <span
          :class="`${anon ? 'g-anon' : '' }`"
        >
          {{ data.item.group_id }}&nbsp;&nbsp;
        </span>
      </template>
      <template v-slot:cell(survey_deleted)="data">
        <span
          @click.prevent.stop="
            survey_delete(
              data.item.id,
              data.item.survey_deleted,
              data.item.survey_status_id,
              data.item.completecount
            )
          "
        >
          <fa-icon
            v-show="data.item.survey_status_id < 5"
            class="text-primary"
            :name="data.item.survey_deleted == 0 ? 'trash-alt' : 'check'"
            @click.prevent.stop="
              survey_delete(
                data.item.id,
                data.item.survey_deleted,
                data.item.survey_status_id,
                data.item.completecount
              )
            "
          />
        </span>
        <span
          @click.prevent.stop="wipeconfirm=true;wipesurvey=data.item.id"
          class="pl-3"
        >
          <fa-icon
            v-show="data.item.survey_deleted == 1"
            class="text-danger"
            :name="'trash'"
            @click.prevent.stop="wipeconfirm=true;wipesurvey=data.item.id"
          />
        </span>
      </template>
    </b-table>
  </div>
</template>
<script>
import SurveyProgressBar from './SurveyProgressBar.vue'

export default {
  components: {
    SurveyProgressBar
  },
  props: {
    surveytype: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      wipeconfirm: false,
      wipeprogress: false,
      wipesurvey: 0,
      consultant_id: this.$store.state.user_id,
      loading: true,
      selected: 0,
      surveysselected: 0,
      fields: [
        {
          key: 'survey_type_id',
          sortable: true,
          label: 'Type',
          tdClass: 'd-none d-sm-none d-md-none d-lg-none d-xl-table-cell',
          thClass: 'd-none d-sm-none d-md-none d-lg-none d-xl-table-cell'
        },
        {
          key: 'group_id',
          sortable: true,
          label: 'Group',
          tdClass: 'd-none d-sm-none d-md-none d-lg-table-cell d-xl-table-cell',
          thClass: 'd-none d-sm-none d-md-none d-lg-table-cell d-xl-table-cell'
        },
        { key: 'survey_name', sortable: true },
        {
          key: 'survey_start_date',
          sortable: true,
          label: 'Start date',
          tdClass: 'd-none d-sm-none d-md-none d-lg-none d-xl-table-cell',
          thClass: 'd-none d-sm-none d-md-none d-lg-none d-xl-table-cell'
        },
        {
          key: 'survey_end_date',
          sortable: true,
          label: 'End date',
          tdClass:
            'd-none d-sm-none d-md-table-cell d-lg-table-cell d-xl-table-cell',
          thClass:
            'd-none d-sm-none d-md-table-cell d-lg-table-cell d-xl-table-cell'
        },
        { key: 'survey_status', sortable: false, label: 'Replied' },
        { key: 'survey_deleted', class: 'col-1', label: '', sortable: false }
      ],
      deleteconfirm: 1,

      surveys: []
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    mygdqpage_reload: {
      get () {
        return this.$store.state.mygdqpage_reload
      }
    },
    setadmin_done: {
      get () {
        return this.$store.state.questionnaire_admin_done
      }
    }
  },
  watch: {
    mygdqpage_reload () {
      this.loading = true
      this.surveys_get()
    },
    setadmin_done () {
      this.loading = true
      this.surveys_get()
    }
  },
  created () {
    this.loading = true
    this.surveys_get()
    this.$store.dispatch('questionnaire_setadmin', { admin: false })
    this.$store.dispatch('questionnaire_setadmin_code', { code: '' })
    this.$store.dispatch('questionnaire_setadmin_done', { done: false })
  },
  methods: {
    async survey_deletefromdatabase (id) {
      this.wipeconfirm = false
      this.wipeprogress = true
      await this.$store.dispatch('groupsurvey_wipe', { id: id })
      this.wipesurvey = 0
      console.log('Wiped')
      this.loading = true
      this.surveys_get()
      this.wipeprogress = false
    },
    survey_delete (id, survey_deleted, survey_status_id, completecount) {
      this.deleteconfirm = 1
      if (survey_deleted == 0) {
        if (
          (survey_status_id == 3 && completecount > 0) ||
          survey_status_id == 4
        ) {
          this.deleteconfirm = 0
          if (
            confirm(
              'This survey has replies from participants, do you really want to delete it?'
            )
          ) {
            this.deleteconfirm = 1
          }
        }
      }
      if (this.deleteconfirm == 1) {
        var newstatus = 1 - survey_deleted
        var survey = {
          id: id,
          survey_deleted: newstatus
        }
        this.$store
          .dispatch('groupsurvey_update', { survey: survey })
          .then(resp => {
            this.surveys_get()
          })
      }
    },
    selectall (selected) {
      var setselectto = !selected
      for (var i = 0; i < this.surveys.length; i++) {
        this.surveys[i].selected = setselectto
      }
      this.countselected()
    },
    countselected () {
      var selectedsurveys = []
      var numbersel = 0
      for (var i = 0; i < this.surveys.length; i++) {
        if (this.surveys[i].selected) {
          selectedsurveys.push(this.surveys[i].id)
          numbersel++
        }
      }
      this.surveysselected = numbersel
      this.$store.dispatch('groupsurveys_setselected', {
        surveys: selectedsurveys
      })
    },
    surveys_get () {
      this.loading = true
      let filter_survey_status_id = 3
      let survey_type_id = this.surveytype
      switch (survey_type_id) {
        case 'ongoing':
          filter_survey_status_id = 3
          break
        case 'drafts':
          filter_survey_status_id = 1
          break
        case 'upcoming':
          filter_survey_status_id = 2
          break
        case 'finished':
          filter_survey_status_id = 4
          break
        default:
          filter_survey_status_id = 3
          break
      }
      let filter = {
        user_id: {
          operator: '=',
          value: this.consultant_id,
          realfield: 1
        },
        survey_status_id: {
          operator: '=',
          value: filter_survey_status_id,
          realfield: 1
        },
        survey_deleted: {
          operator: '=',
          value: 0,
          realfield: 1
        }
      }
      if (this.surveytype == 'deleted') {
        filter = {
          survey_deleted: {
            operator: '=',
            value: 1,
            realfield: 1
          }
        }
      }
      if (this.$store.state.currentgroup_id != 0) {
        filter['group_id'] = {
          operator: '=',
          value: this.$store.state.currentgroup_id,
          realfield: 1
        }
      }
      this.$store.dispatch('surveys_fetch', { filter }).then((resp) => {
        this.surveys = resp.data.result
        this.loading = false
      })
    },
    openSurveyPage (item, index, event) {
      this.$store
        .dispatch('groupsurvey_setcurrent', { survey_id: item.id })
        .then(() => {
          this.$router.push('/group/survey')
        })
    },
    filter_it (row, filter) {
      var include = true
      if (filter == 'drafts') {
        if (row.survey_status_id != 1 || row.survey_deleted == 1) {
          include = false
        }
      }
      if (filter == 'upcoming') {
        if (row.survey_status_id != 2 || row.survey_deleted == 1) {
          include = false
        }
      }
      if (filter == 'ongoing') {
        if (row.survey_status_id != 3 || row.survey_deleted == 1) {
          include = false
        }
      }
      if (filter == 'finished') {
        if (row.survey_status_id != 4 || row.survey_deleted == 1) {
          include = false
        }
      }
      if (filter == 'deleted') {
        if (row.survey_deleted != 1) {
          include = false
        }
      }
      return include
    },
    format_date (date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    format_time (date) {
      var d = new Date(date)
      var h = d.getHours()
      var m = d.getMinutes()
      var hour = (h > 9 ? '' : '0') + h
      var minute = (m > 9 ? '' : '0') + m
      var thistime = hour + ':' + minute
      return thistime
    }
  }
}
</script>
<style>
td {
  cursor: pointer !important;
}
</style>
